export enum AdditionalFlow {
  AuthResetPassword = "AuthResetPassword",
  AuthUpdatePassword = "AuthUpdatePassword",
  AuthResetPin = "AuthResetPin",
  AuthUpdatePin = "AuthUpdatePin",
  AuthResetTfaEmail = "AuthResetTfaEmail",
  AuthResetTfaSMS = "AuthResetTfaSMS",
  AuthResetTfaAuthenticator = "AuthResetTfaAuthenticator",
}
